import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ActionReducer, createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { SCORECARDS_ACTIONS } from '../actions/scorecards.actions';
import { IAccountScorecards } from '../../../feature-modules/insights/pages/manage-scorecards/models/scorecard.model';

export const SCORECARDS_STATE_KEY = 'scorecards';

export interface IScorecardsState extends EntityState<IAccountScorecards> {
  loading: boolean;
  error: Error | null;
}

export const scorecardsAdapter: EntityAdapter<IAccountScorecards> = createEntityAdapter<IAccountScorecards>({
  selectId: (item) => item.accountId,
  sortComparer: (a, b) => a.accountName.localeCompare(b.accountName),
});

export const initialState: IScorecardsState = scorecardsAdapter.getInitialState({
  loading: false,
  error: null,
});

const reducer: ActionReducer<IScorecardsState> = createReducer(
  initialState,
  on(SCORECARDS_ACTIONS.getScorecards, (state) => ({
    ...state,
    loading: true,
  })),
  on(SCORECARDS_ACTIONS.getScorecardsSuccess, (state, { payload }) =>
    scorecardsAdapter.setAll(payload, { ...state, loading: false }),
  ),
  on(SCORECARDS_ACTIONS.getScorecardsError, (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  })),
  on(SCORECARDS_ACTIONS.cleanScorecards, () => initialState),
);

export const SCORECARDS_REDUCER = createFeature({
  name: SCORECARDS_STATE_KEY,
  reducer,
  extraSelectors: ({ selectScorecardsState }) => {
    const { selectAll } = scorecardsAdapter.getSelectors(selectScorecardsState);

    return {
      selectAllScorecards: selectAll,
      isLoading: createSelector(selectScorecardsState, ({ loading }) => loading),
      isError: createSelector(selectScorecardsState, ({ error }) => Boolean(error)),
    };
  },
});
